import { Slutsk } from "./Slutsk.js";
import { Saligorsk } from "./Salihorsk.js";
import { Lyuban } from "./Lyuban.js";
import { StaryyaDarohi } from "./StaryyaDarohi.js";
import { Kapyl } from "./Kapyl.js";
import { Kletsk } from "./Kletsk.js";
import { Byerazino } from "./Byerazino.js";
import { Barysaw } from "./Barysaw.js";
import { Vileyka } from "./Vileyka.js";
import { Valozhyn } from "./Valozhyn.js";
import { Dzyarzhynsk } from "./Dzyarzhynsk.js";
import { Krupki } from "./Krupki.js";
import { Lahoysk } from "./Lahoysk.js";
import { Minskiy } from "./Minskiy.js";
import { Maladzyechna } from "./Maladzyechna.js";
import { Myadzyel } from "./Myadzyel.js";
import { Nyasvizh } from "./Nyasvizh.js";
import { Puchavichy } from "./Puchavichy.js";
import { Smalyavichy } from "./Smalyavichy.js";
import { Stowbtsy } from "./Stowbtsy.js";
import { Uzda } from "./Uzda.js";
import { Chervyen } from "./Chervyen.js";
import { Zhodino } from "./Zhodino.js";

export const regionsService = [
  {
    "d7ef5828-39ec-11ef-895a-0242ac110004": Byerazino,
    "d7ee51da-39ec-11ef-895a-0242ac110004": Barysaw,
    "d7ed6bee-39ec-11ef-895a-0242ac110004": Vileyka,
    "d7ec8b34-39ec-11ef-895a-0242ac110004": Valozhyn,
    "d7ea67e6-39ec-11ef-895a-0242ac110004": Dzyarzhynsk,
    "d7e97afc-39ec-11ef-895a-0242ac110004": Kletsk,
    "d7e887a0-39ec-11ef-895a-0242ac110004": Kapyl,
    "d7e77d38-39ec-11ef-895a-0242ac110004": Krupki,
    "d7e68e78-39ec-11ef-895a-0242ac110004": Lahoysk,
    "d7e58b2c-39ec-11ef-895a-0242ac110004": Lyuban,
    "d7e4aa18-39ec-11ef-895a-0242ac110004": Minskiy,
    "d7e3bb26-39ec-11ef-895a-0242ac110004": Maladzyechna,
    "d7e2d616-39ec-11ef-895a-0242ac110004": Myadzyel,
    "d7e1f5ca-39ec-11ef-895a-0242ac110004": Nyasvizh,
    "d7e0f67a-39ec-11ef-895a-0242ac110004": Puchavichy,
    "d7e0045e-39ec-11ef-895a-0242ac110004": Slutsk,
    "d7def76c-39ec-11ef-895a-0242ac110004": Smalyavichy,
    "d7ddf362-39ec-11ef-895a-0242ac110004": Saligorsk,
    "d7dcc6d6-39ec-11ef-895a-0242ac110004": StaryyaDarohi,
    "d7db7e3e-39ec-11ef-895a-0242ac110004": Stowbtsy,
    "d7d99e16-39ec-11ef-895a-0242ac110004": Uzda,
    "d7d761dc-39ec-11ef-895a-0242ac110004": Chervyen,
    "d7eb5f70-39ec-11ef-895a-0242ac110004": Zhodino,
  },
];
